export const types = {
  SET_PRODUCT_TYPES: "MANUAL/SET_PRODUCT_TYPES",
  SET_PRODUCT_CONFIG: "MANUAL/SET_PRODUCT_CONFIG",
  SET_NOT_SHOW_LANDLINE: "MANUAL/SET_NOT_SHOW_LANDLINE",
  SET_NOT_SHOW_ACCOUNT_BLOCK: "MANUAL/SET_NOT_SHOW_ACCOUNT_BLOCK",
  SET_PHONE_OPTIONS: "MANUAL/SET_PHONE_OPTIONS",
  SET_EXTEND_SELECT_ELEMENTS_NEEDS: "MANUAL/SET_EXTEND_SELECT_ELEMENTS_NEEDS",
  SET_EXTEND_SELECT_ELEMENTS_NEEDS_ACTION_INFO: "MANUAL/SET_EXTEND_SELECT_ELEMENTS_NEEDS_ACTION_INFO",
  SET_EXTEND_SELECT_ELEMENTS_NEEDS_ACTION_ADDITIONAL_INFO: "MANUAL/SET_EXTEND_SELECT_ELEMENTS_NEEDS_ACTION_ADDITIONAL_INFO",
  SET_LMA_BUY_PROCESS_INFO: "MANUAL/SET_LMA_BUY_PROCESS_INFO",
  SET_NUMBER_OF_SIMS: "MANUAL/SET_NUMBER_OF_SIMS",
  SET_TYPE_OF_SIMS: "MANUAL/SET_TYPE_OF_SIMS",
};

export const initialState = {
  productTypes: null,
  productBlocks: ["PersonalData", "Shipment", "Mobile"],
  productInfo: null,
  notShowLandLine: false,
  phoneOptions: null,
  multiSim: {
    numberOfSims: null,
    typeOfSims: [],
  }
};

// eslint-disable-next-line @typescript-eslint/default-param-last
const ManualReducer = (
  state = JSON.parse(JSON.stringify(initialState)),
  action
) => {
  switch (action.type) {
    case types.SET_NUMBER_OF_SIMS: {
      const { numberOfSims } = action.payload;

      const newTypeOfSims = state.multiSim.typeOfSims.slice(0, numberOfSims);

      return {
        ...state,
        multiSim: {
          typeOfSims: newTypeOfSims,
          numberOfSims,
        },
      };
    }
    case types.SET_TYPE_OF_SIMS: {
      const { typeOfSims, simIndex } = action.payload;

      const newTypeOfSims = [...state.multiSim.typeOfSims];

      newTypeOfSims[simIndex] = typeOfSims;

      return {
        ...state,
        multiSim: {
          ...state.multiSim,
          typeOfSims: newTypeOfSims,
        },
      };
    }
    case types.SET_PRODUCT_TYPES: {
      const { productTypes } = action.payload;

      return {
        ...state,
        productTypes,
      };
    }
    case types.SET_NOT_SHOW_LANDLINE: {
      return {
        ...state,
        notShowLandLine: true,
      };
    }
    case types.SET_NOT_SHOW_ACCOUNT_BLOCK: {
      return {
        ...state,
        notShowAccountBlock: true,
      };
    }
    case types.SET_PRODUCT_CONFIG: {
      const { productConfig } = action.payload;

      const { productBlocks, productInfo, r2rRenewalInfo } = productConfig;

      return {
        ...state,
        productBlocks,
        productInfo,
        r2rRenewalInfo,
      };
    }
    case types.SET_PHONE_OPTIONS: {
      const { phoneOptions } = action.payload;

      return {
        ...state,
        phoneOptions,
      };
    }
    case types.SET_LMA_BUY_PROCESS_INFO: {
      const { lmaBuyProcessUrl, lmaName, lmaPrice, bafName } = action.payload;

      return {
        ...state,
        lmaBuyProcessUrl,
        lmaName,
        lmaPrice,
        bafName,
      };
    }
    case types.SET_EXTEND_SELECT_ELEMENTS_NEEDS: {
      const {
        mainOptionsForUI,
        productOffering,
        productType,
        cqId,
        newActualProductOffering,
      } = action.payload;

      const { mainOptionSelected, options } = mainOptionsForUI;

      return {
        ...state,
        extendSelectElementsNeeds: {
          cqId,
          productOfferingChanged: !!newActualProductOffering,
          mainOptionsObj: {
            mainOptions: {
              customerQuoteItems: options,
              id: "MAIN",
            },
            productType,
            mainOptionSelected,
          },
          secondaryOptionsObj: null,
          productOffering,
        },
      };
    }
    case types.SET_EXTEND_SELECT_ELEMENTS_NEEDS_ACTION_INFO: {
      const {
        actionId,
      } = action.payload;


      return {
        ...state,
        extendSelectElementsNeeds: {
          ...state.extendSelectElementsNeeds,
          mainOptionsObj: {
            ...state.extendSelectElementsNeeds.mainOptionsObj,
            mainOptionSelected: actionId,
            phoneNumber: undefined,
          },
        },
      };
    }
    case types.SET_EXTEND_SELECT_ELEMENTS_NEEDS_ACTION_ADDITIONAL_INFO: {
      const {
        phoneNumber,
      } = action.payload;

      return {
        ...state,
        extendSelectElementsNeeds: {
          ...state.extendSelectElementsNeeds,
          mainOptionsObj: {
            ...state.extendSelectElementsNeeds.mainOptionsObj,
            phoneNumber,
          },
        },
      };
    }
    default:
      return { ...state };
  }
};

export const actions = {
  setNumberOfSims: (numberOfSims) => ({
    type: types.SET_NUMBER_OF_SIMS,
    payload: {
      numberOfSims,
    },
  }),
  setTypeOfSims: (typeOfSims, simIndex) => ({
    type: types.SET_TYPE_OF_SIMS,
    payload: {
      typeOfSims,
      simIndex
    },
  }),
  setProductTypes: (productTypes) => ({
    type: types.SET_PRODUCT_TYPES,
    payload: {
      productTypes,
    },
  }),
  setProductConfig: (productConfig) => ({
    type: types.SET_PRODUCT_CONFIG,
    payload: {
      productConfig,
    },
  }),
  setNotShowLandLine: () => ({
    type: types.SET_NOT_SHOW_LANDLINE,
  }),
  setNotShowAccountBlock: () => ({
    type: types.SET_NOT_SHOW_ACCOUNT_BLOCK,
  }),
  setPhoneOptions: (phoneOptions) => ({
    type: types.SET_PHONE_OPTIONS,
    payload: {
      phoneOptions,
    },
  }),
  setExtendSelectElementsNeeds: (info) => ({
    type: types.SET_EXTEND_SELECT_ELEMENTS_NEEDS,
    payload: {
      ...info,
    },
  }),
  setExtendSelectElementsNeedsActionInfo: (actionObj) => ({
    type: types.SET_EXTEND_SELECT_ELEMENTS_NEEDS_ACTION_INFO,
    payload: {
      ...actionObj,
    },
  }),
  setExtendSelectElementsNeedsActionAdditionalInfo: (secondaryActionObj) => ({
    type: types.SET_EXTEND_SELECT_ELEMENTS_NEEDS_ACTION_ADDITIONAL_INFO,
    payload: {
      ...secondaryActionObj,
    },
  }),
  setLMABuyProcessInfo: ({lmaAltBuyProcessInfo}) => ({
    type: types.SET_LMA_BUY_PROCESS_INFO,
    payload: {
      ...lmaAltBuyProcessInfo,
    },
  }),
};

export default ManualReducer;
